import React, { useLayoutEffect, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

/**
 * Sends the window back to the top on every route change. Renders nothing.
 * html carries scroll-behavior:smooth, so this needs behavior:'instant' or
 * navigation animates all the way up from the previous page's offset.
 * useLayoutEffect, not useEffect, so the reset lands before paint.
 */
export const ScrollToTopOnNavigate = () => {
  const { pathname, hash } = useLocation();
  useLayoutEffect(() => {
    if (hash) return; // an anchor target owns the scroll position
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

/** The floating back-to-top control. */
export const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className="fixed bottom-7 right-7 z-40 w-11 h-11 rounded-full grid place-items-center bg-ink text-lime ring-1 ring-lime/30 shadow-xl hover:bg-lime hover:text-ink transition-colors"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};
